<script setup>
import { useRoute } from 'vue-router'
import axios from "axios"
import {onMounted, ref} from "vue"
import Swal from 'sweetalert2'

const route = useRoute()
// const posts = ref({})
const title = ref('')
const body = ref('')
const photoFile  = ref(null)
const titleErore = ref(false)
const bodyErore = ref(false)
const imgErore = ref(false)


onMounted(async () => {

  try {
    const response = await axios.get("https://jsonplaceholder.typicode.com/posts/"+route.query.id)
    title.value =(response.data.title)
    body.value =(response.data.body)
  } catch (err) {
    // error.value = 'خطا در دریافت اطلاعات'
    console.error(err)
  } finally {
    // loading.value = false
  }
})


async function updateproduct() {

  loaded.value = true
  if (title.value== ''){
    titleErore.value=true;
  }
  if (body.value== ''){
    bodyErore.value=true;
  }

  const formData = new FormData()
  formData.append('title', title.value)
  formData.append('body', body.value)
  formData.append('photoFile', photoFile.value)

  try {
    // const response = await axios.put("https://jsonplaceholder.typicode.com/posts/"+route.query.id)
    const response = await axios.post('https://fixstyle.ir/api/product2',formData)
    // posts.value =(response.data)
    console.log(response.data)
    loaded.value = false
    if (response.status === 200){
      Swal.fire({
        title: "Good job!",
        text: "You clicked the button!",
        icon: "success",
        footer: '<a href="/products">لیست کل محصولات</a>'
      });
    }
    else {
      Swal.fire({
        title: 'Error!',
        text: 'Do you want to continue',
        icon: 'error',
        confirmButtonText: 'Cool'
      })
    }

  } catch (err) {
    // error.value = 'خطا در دریافت اطلاعات'
    /*Swal.fire({
      title: 'Error!',
      text: 'خطا در دریافت اطلاعات',
      icon: 'error',
      confirmButtonText: 'Cool'
    })*/
    console.error(err)
  } finally {
    // loading.value = false
  }
}

const loaded = ref(false)
const base64Image = ref('')
function importimg(event) {
  const file=event.target.files[0]
  if (file) {
    photoFile.value = file
    const reader = new FileReader()
    reader.readAsDataURL(file) // تبدیل فایل به base64
    reader.onload = () => {
      base64Image.value = reader.result // رشته base64 را ذخیره می‌کنیم
    }
    reader.onerror = (error) => {
      console.error('خطا در خواندن فایل:', error)
    }
  }

}

</script>

<template>
<h1>Editproduct</h1>
<!--  <p>{{route.query.id}}</p>
  <p>{{posts.id}}</p>
  <p>{{posts.userId}}</p>
  <p>{{posts.title}}</p>
  <p>{{posts.body}}</p>-->

  <div class="row justify-content-center">
    <div class="col-6">
      <form class="row g-3 needs-validation  " :class="{'was-validated':titleErore|| bodyErore}"  >
        <div class="mb-3">
          <label for="exampleInputEmail1" class="form-label">عنوان</label>
          <input v-model="title" type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" required>
          <!--      <div id="emailHelp" class="form-text">We'll never share your title with anyone else.</div>-->
          <div class="invalid-feedback" v-if="titleErore">
            لطفا عنوان را کامل کنید
          </div>
        </div>
        <div class="mb-3">
          <label for="exampleInputPassword1" class="form-label">متن</label>
          <input v-model="body" type="text" class="form-control" id="exampleInputPassword1" required>
          <div class="invalid-feedback" v-if="bodyErore">
            لطفا متن را کامل کنید
          </div>
        </div>
        <div class="mb-3">
          <label for="fileimg" class="form-label">عکس</label>
          <input   @change="importimg"   type="file" class="form-control" id="fileimg" accept="image/*" required>
          <div class="invalid-feedback" v-if="imgErore">
            لطفا عکس را کامل کنید
          </div>


        </div>

        <button type="submit" class="btn btn-primary " :class="{'disabled':loaded}"  @click.prevent="updateproduct">
          <span v-if="loaded" class="image-loader-placeholder text-center my-3">
            <span class="spinner-border spinner-border-sm mx-3"></span>در حال ارسال...
          </span>
          <span v-if="!loaded">
             ارسال
          </span>

        </button>
      </form>
    </div>
    <div class="col-6">
      <div v-if="base64Image">
        <p>پیش‌نمایش:</p>
        <img :src="base64Image" alt="Preview" style="max-width: 200px;" />
      </div>
    </div>
  </div>



</template>

<style scoped>

</style>